import { ApiFetchParams, useApiQuery } from "../helpers/useApi"
import { Location, LocationArea } from "../models/filters";

export type DeviceGroup = {
	id: number;
	name: string;
}

export type DeviceType = {
	id: number;
	name: string;
}

export type CompanyConfig = {
    locations: Location[],
    locationAreas:LocationArea[],
    tenderTypes:
    {
        id: number,
        name: string,
        description: string
    }[],
    staff:
    {
        id: number,
        name: string,
        mainLocationId: number
    }[],
    devices:
    {
        id: number,
        name: string,
        locationId: string
    }[],
    deviceGroups: DeviceGroup[],
    deviceTypes: DeviceType[]
}

export function useCompanyConfig<T>(queryKey: string) {
    return useApiQuery<CompanyConfig>({
        path: `/data/v1/company/config`,
        body: {}
    } as ApiFetchParams, queryKey);
}
